import Uploader from './src';

export default Uploader;



// WEBPACK FOOTER //
// ./src/components/uploader/index.js